(function() { module.exports = window["moment"]; }());